<p-dialog
  [closeOnEscape]="true"
  [visible]="showCallOutcome()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1199px': '100vw' }"
  (onHide)="setHidePopup()"
  [style]="{ width: '1220px' }"
  styleClass="no-header-modal"
  aria-label="call-outcome-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />

  <ng-template pTemplate="content" styleClass="p-0">
    <div class="grid m-0" aria-label="call-outcome-container">
      <!-- left side -->
      <div
        class="col-12 lg:col-4 hidden lg:block surface-100 p-0 border-right-2 border-300"
        aria-label="client-info-section"
      >
        <!-- Header -->
        @if (modelData()?.client_info) {
          <div
            class="bg-blue-50 py-2 px-3 h-3rem md:h-4rem flex align-items-center"
          >
            <span
              class="bg-green-500 px-2 py-1 line-height-3 font-bold border-round text-white text-xxs"
              aria-label="client-status"
              >{{ modelData()?.client_info?.status | uppercase }}</span
            >
            <div
              class="relative mx-2 w-6rem h-2rem overflow-hidden flex align-items-center"
              aria-label="stage-info"
            >
              @if (
                getStageStatus(modelData()?.stage_master_id) | async;
                as strStage
              ) {
                <img
                  src="/assets/img/icons/opportunity-stage-bg.svg"
                  class="absolute w-6rem h-2rem"
                  alt="Stage Background"
                /><span
                  class="relative z1 text-xs text-primary font-bold ml-2 w-10 block overflow-hidden text-overflow-ellipsis white-space-nowrap text-ellipsis block line-height-4"
                  aria-label="stage-name"
                >
                  {{ strStage }}
                </span>
              }
            </div>
            <div
              class="relative overflow-hidden flex align-items-center cursor-pointer"
              (click)="goToClientProfile(modelData()?.client_info?.id)"
              aria-label="client-profile-link"
            >
              <span class="w-2rem h-2rem mr-2" aria-label="client-avatar">
                @if (modelData()?.client_info?.image) {
                  <p-avatar
                    [image]="modelData()?.client_info?.image"
                    shape="circle"
                    aria-label="client-image"
                  />
                } @else {
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                    aria-label="client-initials"
                  />
                }
                <ng-template #noContactPic1>
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                    aria-label="client-initials"
                  />
                </ng-template>
              </span>
              <h3 class="mb-0 text-primary text-base" aria-label="client-name">
                {{ modelData()?.client_info?.full_name }}
              </h3>
              <p
                class="mb-0 text-xs text-600 ml-2 hidden md:block"
                aria-label="client-id"
              >
                - {{ modelData()?.client_info?.id }}
              </p>
            </div>
          </div>
        }
        <!-- Header -->

        @if (modelData()?.client_info) {
          <div
            class="border-top-1 border-bottom-1 border-300 surface-0 p-3 flex align-items-center text-xs"
            aria-label="contact-info-section"
          >
            <div
              class="flex align-items-center mr-5 white-space-nowrap"
              aria-label="phone-info"
            >
              <i class="fa fa-phone mr-3" aria-label="phone-icon"></i>
              <strong aria-label="phone-number"
                >{{ modelData()?.client_info?.mobile_country_code }}
                {{ modelData()?.client_info?.mobile_number }}</strong
              >
            </div>
            <div
              class="flex align-items-center break-word"
              aria-label="email-info"
            >
              <i
                class="fa fa-envelope font-light text-600 mr-2"
                aria-label="email-icon"
              ></i>
              <span class="text-primary" aria-label="email-address">{{
                modelData()?.client_info?.email_id
              }}</span>
            </div>
          </div>
        }

        <div class="p-3">
          <!-- <app-task-opportunity-info [taskOpportunityInfo]="modelData"></app-task-opportunity-info> -->
          <app-task-opportunity-info
            [taskOpportunityInfo]="modelData()"
            (ErrorData)="GetErrorData($event)"
            (UpdatedData)="GetUpdatedData($event)"
            aria-label="task-opportunity-info"
          />
        </div>
      </div>

      <!-- left side -->

      <!-- Right Side -->
      <div
        class="col-12 lg:col-8 px-0 relative pb-8 pt-0"
        aria-label="outcome-section"
      >
        <!-- Top Area -->
        <div>
          <!-- Header -->
          <div
            class="p-3 sticky right-0 top-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
            aria-label="outcome-header"
          >
            <h2 class="mb-0 text-lg" aria-label="outcome-title">
              {{ 'OUTCOME.CALLOUTCOME.HOW-DID-CALL-GO' | translate }}
            </h2>
            <i
              class="fa fa-times text-xl text-600 cursor-pointer"
              (click)="setHidePopup()"
              data-testid="close-dialog-button"
            ></i>
          </div>
          <!-- Header -->

          <!-- Dropdown -->
          <div class="relative z-1" aria-label="mobile-client-info">
            <div
              class="bg-blue-50 flex align-items-center justify-content-between py-2 px-3 h-3rem md:h-4rem border-bottom-1 border-300 lg:hidden"
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="scalein"
              leaveToClass="hidden"
              leaveActiveClass="fadeout"
              aria-label="mobile-client-header"
            >
              <div
                class="flex align-items-center my-1"
                (click)="goToClientProfile(modelData()?.client_info?.id)"
                aria-label="mobile-client-profile-link"
              >
                <span class="mr-2" aria-label="mobile-client-avatar">
                  @if (modelData()?.client_info?.image) {
                    <img
                      [src]="modelData()?.client_info?.image"
                      class="border-circle"
                      width="32"
                      alt="Avatar"
                    />
                  } @else {
                    <p-avatar
                      [label]="
                        modelData()?.client_info?.full_name
                          | titlecase
                          | shortName
                      "
                      shape="circle"
                    />
                  }
                  <ng-template #noContactPic2>
                    <p-avatar
                      [label]="
                        modelData()?.client_info?.full_name
                          | titlecase
                          | shortName
                      "
                      shape="circle"
                    />
                  </ng-template>
                </span>
                <span
                  class="text-primary font-bold text-lg mr-2"
                  aria-label="mobile-client-name"
                  >{{ modelData()?.client_info?.full_name }}</span
                >
                <span
                  class="text-600 font-normal text-sm"
                  aria-label="mobile-client-id"
                  >{{ modelData()?.client_info?.id }}</span
                >
              </div>
              <div
                class="flex align-items-center"
                aria-label="mobile-client-status"
              >
                <div [innerHTML]="clientStatus(modelData()?.client_info)"></div>
                <i
                  class="fa fa-circle-chevron-down text-xl ml-2 text-primary"
                  aria-label="status-dropdown-icon"
                ></i>
              </div>
            </div>

            <div
              class="surface-50 p-0 m-0 border-round shadow-0 lg:shadow-2 lg:absolute hidden origin-top w-full"
              aria-label="mobile-task-info"
            >
              <!-- Content -->
              <div class="p-3" aria-label="mobile-task-details">
                <!-- <app-task-opportunity-info [taskOpportunityInfo]="modelData"></app-task-opportunity-info> -->
                <app-task-opportunity-info
                  [taskOpportunityInfo]="modelData()"
                  (ErrorData)="GetErrorData($event)"
                  (UpdatedData)="GetUpdatedData($event)"
                  aria-label="mobile-task-opportunity-info"
                />
              </div>
              <!-- Content -->
            </div>
          </div>
          <!-- Dropdown -->

          @if (modelData()?.client_info) {
            <div
              class="border-bottom-1 border-300 lg:hidden surface-0 p-3 flex align-items-center text-xs"
              aria-label="mobile-contact-info"
            >
              <div
                class="flex align-items-center mr-5 white-space-nowrap"
                aria-label="mobile-phone-info"
              >
                <i
                  class="fa fa-phone text-600 mr-2"
                  aria-label="mobile-phone-icon"
                ></i>
                <strong aria-label="mobile-phone-number"
                  >{{ modelData()?.client_info?.mobile_country_code }}
                  {{ modelData()?.client_info?.mobile_number }}</strong
                >
              </div>
              <div
                class="flex align-items-center mr-3 break-word"
                aria-label="mobile-email-info"
              >
                <i
                  class="fa fa-envelope font-light text-600 mr-2"
                  aria-label="mobile-email-icon"
                ></i>
                <span class="text-primary" aria-label="mobile-email-address">{{
                  modelData()?.client_info?.email_id
                }}</span>
              </div>
            </div>
          }

          <!-- Content -->
          <div class="px-3 py-4" aria-label="outcome-selection-section">
            <h6
              class="text-xs font-normal md:mb-0 mb-2 text-600"
              aria-label="outcome-label"
            >
              {{ 'OUTCOME.CALLOUTCOME.CALL-OUTCOME' | translate }}
            </h6>

            <div
              class="p-buttonset hidden lg:block"
              aria-label="outcome-buttons"
            >
              @for (item of outcome$ | async; track item; let i = $index) {
                <button
                  pButton
                  pRipple
                  class="text-sm mt-2"
                  (click)="SelectOutcome(item)"
                  label="{{ item.name }}"
                  icon="{{ item.icon }}"
                  [ngClass]="selectedOutcome === item ? item.class : 'p-button-secondary'"
                  [attr.aria-label]="'outcome-button-' + item.name"
                ></button>
              }
            </div>

            <div
              class="block lg:hidden mt-2"
              aria-label="mobile-outcome-dropdown"
            >
              <p-select
                placeholder=" {{ 'OUTCOME.CALLOUTCOME.SELECT' | translate }}"
                [options]="outcome$ | async"
                (onChange)="SelectOutcomeMob($event)"
                optionLabel="name"
                styleClass="w-full"
                aria-label="outcome-select"
              >
                <ng-template pTemplate="selectedItem">
                  @if (selectedOutcome) {
                    <div class="flex align-items-center">
                      <span class="mr-2"
                        ><i
                          style="color:'{{ selectedOutcome.iconColor }}'"
                          class="{{ selectedOutcome.icon }}"
                        ></i
                      ></span>
                      <strong>{{ selectedOutcome.name }}</strong>
                    </div>
                  }
                </ng-template>
                <ng-template let-outcome pTemplate="item">
                  <div class="flex align-items-center">
                    <span class="mr-2"
                      ><i
                        style="color:'{{ outcome.iconColor }}'"
                        class="{{ outcome.icon }}"
                      ></i
                    ></span>
                    <div class="text-sm text-600">
                      {{  outcome.name | translate }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
          <!-- Content -->

          <!-- Info Box -->
          <div
            class="surface-100 p-3 flex align-items-center"
            aria-label="info-box"
          >
            <i class="fa fa-info-circle text-600" aria-label="info-icon"></i>
            <span class="text-xs text-600" aria-label="info-text">{{
              'OUTCOME.CALLOUTCOME.CALL-OUTCOME-ABOUT' | translate
            }}</span>
          </div>
          <!-- Info Box -->

          <!-- Choose Your Outcome -->
          <ng-container
            *ngTemplateOutlet="selectedOutcome ? getoutcome : chooseoutcome"
          />
          <!-- Choose Your Outcome -->
        </div>
        <!-- Top Area -->
      </div>
      <!-- Right Side -->

      <!-- </form> -->
    </div>
  </ng-template>

  <ng-template #chooseoutcome>
    <div class="px-3 py-5 text-center" aria-label="choose-outcome-section">
      <h2 class="mb-4 text-lg md:text-2xl" aria-label="choose-outcome-title">
        {{ 'OUTCOME.TOUROUTCOME.CHOOSEOUTCOME' | translate }}
      </h2>
      <img
        width="260"
        src="assets/img/call-outcome-img.svg"
        alt="Image"
        aria-label="outcome-illustration"
      />
    </div>
  </ng-template>

  <ng-template #noanswer>
    <form
      [formGroup]="frmCallOutComeNoAnswer"
      (ngSubmit)="CreateCallOutcomeNoAnswer(frmCallOutComeNoAnswer)"
      aria-label="no-answer-form"
    >
      <!-- Choose Your Outcome -->
      <div class="px-3 py-5" aria-label="no-answer-content">
        <div
          class="flex align-items-center md:mb-6 mb-4"
          aria-label="mark-complete-section"
        >
          <p-toggleSwitch
            formControlName="noanswer_markascomplete"
            (onChange)="toggleNoAnswer($event.checked)"
            aria-label="mark-complete-switch"
          />
          <h5 class="text-sm mb-0 ml-3 -mt-1" aria-label="mark-complete-label">
            {{ 'OUTCOME.TOUROUTCOME.MARKTASKCOMPLETED' | translate }}
          </h5>
        </div>

        <div class="grid" aria-label="followup-section">
          <div class="col-12 py-0">
            <h5
              class="text-xs text-600 font-normal mb-0 uppercase"
              aria-label="followup-date-label"
            >
              {{ 'OUTCOME.CALLOUTCOME.SELECT-NEXT-FOLLOWUP-DATE' | translate }}
            </h5>
          </div>
          <div class="col-12 md:col-4">
            <p-datepicker
              [showIcon]="true"
              dateFormat="dd-M-yy"
              formControlName="noanswer_expecteddate"
              (keyup)="$event.preventDefault()"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTDATE' | translate }}"
              inputStyleClass="text-sm"
              aria-label="followup-date-picker"
            />
            @if (
              getNoAnswer_ExpectedDate.touched &&
              getNoAnswer_ExpectedDate.invalid
            ) {
              <app-error-msg
                [errors]="getNoAnswer_ExpectedDate.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.DATE' | translate"
                aria-label="followup-date-error"
              />
            }
          </div>
          <div class="col-12 md:col-4 mt-1 md:mt-0">
            <p-datepicker
              icon="fa fa-clock"
              hourFormat="12"
              [timeOnly]="true"
              inputId="timeonly"
              [showIcon]="true"
              formControlName="noanswer_expectedtime"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTTIME' | translate }}"
              StyleClass="text-sm"
              inputStyleClass="text-sm"
              aria-label="followup-time-picker"
            />
            @if (
              getNoAnswer_ExpectedTime.touched &&
              getNoAnswer_ExpectedTime.invalid
            ) {
              <app-error-msg
                [errors]="getNoAnswer_ExpectedTime.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.TIME' | translate"
                aria-label="followup-time-error"
              />
            }
          </div>
          <div class="col-12 mt-4">
            <h5
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="notes-label"
            >
              {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}
            </h5>
            <textarea
              pInputTextarea
              class="p-inputtextarea p-inputtext p-component p-element w-full"
              formControlName="noanswer_notes"
              aria-label="notes-input"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- Choose Your Outcome -->
      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full"
        aria-label="no-answer-footer"
      >
        <div class="flex align-items-center justify-content-between">
          <div class="w-6">
            <p-button
              label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
              styleClass="p-button-link text-sm"
              (click)="setHidePopup()"
              aria-label="cancel-button"
              data-testid="cancel-button"
            />
          </div>
          <div class="col-6 text-right">
            <button
              pButton
              pRipple
              label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
              type="submit"
              aria-label="submit-button"
              data-testid="submit-button"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #contactmade>
    <form
      [formGroup]="frmCallOutcomeContactmade"
      (ngSubmit)="CreateCallOutcomeContactMade(frmCallOutcomeContactmade)"
    >
      <div class="px-3 py-5">
        <div class="grid">
          <div class="col-12 py-0">
            <h5 class="text-xs text-600 font-normal mb-0 uppercase">
              {{ 'OUTCOME.CALLOUTCOME.SELECT-NEXT-FOLLOWUP-DATE' | translate }}
            </h5>
          </div>
          <div class="col-12 md:col-4">
            <p-datepicker
              [showIcon]="true"
              dateFormat="dd-M-yy"
              formControlName="contactmade_expecteddate"
              (keyup)="$event.preventDefault()"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTDATE' | translate }}"
              inputStyleClass="text-sm"
            />
            @if (
              getContactMade_ExpectedDate.touched &&
              getContactMade_ExpectedDate.invalid
            ) {
              <app-error-msg
                [errors]="getContactMade_ExpectedDate.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.DATE' | translate"
              />
            }
          </div>
          <div class="col-12 md:col-4 mt-1 md:mt-0">
            <p-datepicker
              icon="fa fa-clock"
              hourFormat="12"
              [timeOnly]="true"
              inputId="timeonly"
              [showIcon]="true"
              formControlName="contactmade_expectedtime"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTTIME' | translate }}"
              StyleClass="text-sm"
              inputStyleClass="text-sm"
            />
            @if (
              getContactMade_ExpectedTime.touched &&
              getContactMade_ExpectedTime.invalid
            ) {
              <app-error-msg
                [errors]="getContactMade_ExpectedTime.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.TIME' | translate"
              />
            }
          </div>
          <div class="col-12 mt-4">
            <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
              {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}
            </h5>
            <textarea
              pInputTextarea
              class="p-inputtextarea p-inputtext p-component p-element w-full"
              formControlName="contactmade_notes"
            ></textarea>
            @if (getContactMade_Notes.touched && getContactMade_Notes.invalid) {
              <app-error-msg
                [errors]="getContactMade_Notes.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.NOTES' | translate"
              />
            }
          </div>
        </div>
      </div>
      <!-- Choose Your Outcome -->
      <div
        class="p-3 border-top-1 border-400 absolute right-0 bottom-0 w-full flex align-items-center justify-content-between"
      >
        <div class="w-6">
          <p-button
            label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
            styleClass="p-button-link text-sm"
            (click)="setHidePopup()"
          />
        </div>
        <div class="w-6 text-right">
          <button
            pButton
            pRipple
            class="text-sm"
            label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
            type="submit"
          ></button>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #notintrested>
    <form
      [formGroup]="frmCallOutNotInterested"
      (ngSubmit)="CreateNotInteresredNotInterested()"
    >
      <!-- Choose Your Outcome -->
      <div class="px-3 py-5">
        <div class="flex align-items-center mb-4">
          <p-toggleSwitch formControlName="notintrested_markcompleted" />
          <h5 class="text-sm mb-0 ml-3 -mt-1">
            {{ 'OUTCOME.CALLOUTCOME.MARKTASKCOMPLETED' | translate }}
          </h5>
        </div>
        <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}
        </h5>
        <textarea
          pInputTextarea
          class="p-inputtextarea p-inputtext p-component p-element w-full"
          formControlName="notintrested_notes"
        ></textarea>
        @if (getNotInterested_Notes.touched && getNotInterested_Notes.invalid) {
          <app-error-msg
            [errors]="getNotInterested_Notes.errors"
            [fieldLabel]="'OUTCOME.CALLOUTCOME.NOTES' | translate"
          />
        }
      </div>
      <!-- Choose Your Outcome -->
      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full"
      >
        <div class="flex align-items-center justify-content-between">
          <div class="w-6">
            <p-button
              label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
              styleClass="p-button-link text-sm"
              (click)="setHidePopup()"
            />
          </div>
          <div class="w-6 text-right">
            <button
              pButton
              pRipple
              class="text-sm"
              label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
              type="submit"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #booktour>
    <form
      [formGroup]="frmCallOutcomeBookTour"
      (ngSubmit)="CreateCallOutcomeBookTour(frmCallOutcomeBookTour)"
    >
      <!-- Choose Your Outcome -->
      <div class="px-3 py-5">
        <div class="grid">
          <div class="col-12 py-0">
            <h5 class="text-xs text-600 font-normal mb-0 uppercase">
              {{ 'OUTCOME.CALLOUTCOME.SELECT-TOUR-DATE' | translate }}
            </h5>
          </div>
          <div class="col-12 md:col-4">
            <p-datepicker
              [showIcon]="true"
              dateFormat="dd-M-yy"
              formControlName="booktour_expecteddate"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTDATE' | translate }}"
              inputStyleClass="text-sm"
            />

            @if (
              getBookTour_ExpectedDate.touched &&
              getBookTour_ExpectedDate.invalid
            ) {
              <app-error-msg
                [errors]="getBookTour_ExpectedDate.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.DATE' | translate"
              />
            }
          </div>
          <div class="col-12 md:col-4 mt-1 md:mt-0">
            <p-datepicker
              hourFormat="12"
              [timeOnly]="true"
              icon="fa fa-clock"
              inputId="timeonly"
              [showIcon]="true"
              formControlName="booktour_expectedtime"
              placeholder="{{ 'OUTCOME.CALLOUTCOME.SELECTTIME' | translate }}"
              StyleClass="text-sm"
              inputStyleClass="text-sm"
            />

            @if (
              getBookTour_ExpectedTime.touched &&
              getBookTour_ExpectedTime.invalid
            ) {
              <app-error-msg
                [errors]="getBookTour_ExpectedTime.errors"
                [fieldLabel]="'OUTCOME.CALLOUTCOME.TIME' | translate"
              />
            }
          </div>
          <div class="col-12 mt-4">
            <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
              {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}
            </h5>
            <textarea
              pInputTextarea
              class="p-inputtextarea p-inputtext p-component p-element w-full"
              formControlName="booktour_notes"
            ></textarea>
          </div>
        </div>
      </div>
      <!-- Choose Your Outcome -->
      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full"
      >
        <div class="flex align-items-center justify-content-between">
          <div class="w-6">
            <p-button
              label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
              styleClass="p-button-link text-sm"
              (click)="setHidePopup()"
            />
          </div>
          <div class="w-6 text-right">
            <button
              pButton
              pRipple
              class="text-sm"
              label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
              type="submit"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #successfullfollowup>
    <form
      [formGroup]="frmCallOutcomeSuccessfullFollowup"
      (ngSubmit)="CreateSuccessFullFollowUp()"
    >
      <!-- Choose Your Outcome -->
      <div class="px-3 py-5">
        <div class="flex align-items-center mb-4">
          <p-toggleSwitch formControlName="successfulfollowup_markcompleted" />
          <h5 class="text-sm mb-0 ml-3 -mt-1">
            {{ 'OUTCOME.CALLOUTCOME.MARKTASKCOMPLETED' | translate }}
          </h5>
        </div>
        <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}
        </h5>
        <textarea
          pInputTextarea
          class="p-inputtextarea p-inputtext p-component p-element w-full"
          formControlName="successfulfollowup_notes"
        ></textarea>
        @if (getNotInterested_Notes.touched && getNotInterested_Notes.invalid) {
          <app-error-msg
            [errors]="getNotInterested_Notes.errors"
            [fieldLabel]="'OUTCOME.CALLOUTCOME.NOTES' | translate"
          />
        }
      </div>
      <!-- Choose Your Outcome -->
      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full"
      >
        <div class="flex align-items-center justify-content-between">
          <div class="w-6">
            <p-button
              label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
              styleClass="p-button-link text-sm"
              (click)="setHidePopup()"
            />
          </div>
          <div class="w-6 text-right">
            <button
              pButton
              pRipple
              class="text-sm"
              label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
              type="submit"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</p-dialog>

@if (showPaidFullSidebar) {
  <billing
    (onHide)="closeBillingSidebar()"
    [billedAtTenantId]="tenantId"
    [planSummarydata]="planSummarydataObject$"
    [showbilling]="showPaidFullSidebar"
    closeOnEscape="false"
    (closeSidePopupMember)="hideBillingSummary($event)"
    (GoToClientSubscription)="GoToClientDetails($event)"
    aria-label="billing-sidebar"
  />
}


@if (ShowErrorPopup | async; as showPopup) {
  <app-errors
    [visible]="showPopup"
    (onHide)="closeErrorDialog()"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-popup"
  />
}

@if (showChooseReason) {
  <app-lost-deal
    [showDailog]="showChooseReason"
    (closeMainDailog)="closeDailog()"
    [lostDealInfo]="lostDealItemInfo"
    aria-label="lost-deal-dialog"
  />
}
